import React, { useEffect, useRef, forwardRef } from 'react'
import { Rate as AntRate } from 'antd'

const AccessibleRate = forwardRef((props, ref) => {
  const containerRef = useRef(null)

  useEffect(() => {
    const updateRoles = () => {
      if (containerRef.current) {
        const lis = containerRef.current.querySelectorAll('.ant-rate-star')
        lis.forEach((li) => {
          li.setAttribute('role', 'presentation')
        })
      }
    }

    updateRoles()

    let observer
    if (containerRef.current) {
      observer = new MutationObserver(() => {
        updateRoles()
      })
      observer.observe(containerRef.current, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      })
    }

    return () => {
      if (observer) {
        observer.disconnect()
      }
    }
  }, [])

  return (
    <div ref={containerRef} style={{ display: 'inline-block' }}>
      <AntRate ref={ref} {...props} />
    </div>
  )
})

AccessibleRate.displayName = 'AccessibleRate'

export default AccessibleRate
